import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import KinerjaKSIndexApp from 'app/KinerjaKSPage/pages'
import { SchoolProvider } from 'app/KinerjaKSPage/components/SchoolContentProvider'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import PageGuardKs from 'app/KinerjaKSPage/components/PageGuardKs'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ks-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaKSIndex = (props: PageProps) => {
  return (
    <KinerjaTipeProvider tipe="SPF">
      <PageGuardKs>
        <SchoolProvider>
          <KinerjaKSIndexApp {...props} />
        </SchoolProvider>
      </PageGuardKs>
    </KinerjaTipeProvider>
  )
}

KinerjaKSIndex.Layout = KinerjaLayout

KinerjaKSIndex.layoutOpts = {
  hasHeader: true,
}

export default KinerjaKSIndex
